// components/ProtectedRoute.jsx
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ requiredRole }) {
    const { user, loading } = useAuth();

    // Wait for verification to finish
    if (loading) return <p>Loading…</p>;

    // 1. Not logged in at all
    if (!user) return <Navigate to="/login" />;

    // 2. Logged in but wrong role
    if (requiredRole && user.role !== requiredRole) return <Navigate to="/" />;

    // 3. All good
    return <Outlet />;
}